<script setup lang="ts">
import { useElementSize } from '@vueuse/core'

const PREVIEW_HEIGHT = 844

const props = withDefaults(defineProps<{ width?: number }>(), { width: 390 })

const containerRef = useTemplateRef<HTMLElement>('containerRef')
const { height: availableHeight, width: availableWidth } = useElementSize(containerRef, {
  width: props.width,
  height: PREVIEW_HEIGHT
})

const scale = computed(() => Math.min(1, availableHeight.value / PREVIEW_HEIGHT, availableWidth.value / props.width))

const scaledDimensions = computed(() => ({
  width: props.width * scale.value,
  height: PREVIEW_HEIGHT * scale.value
}))
</script>

<template>
  <div ref="containerRef" class="flex min-h-0 w-full items-center justify-center">
    <div
      class="relative shrink-0"
      :style="{
        width: `${scaledDimensions.width}px`,
        height: `${scaledDimensions.height}px`
      }"
    >
      <div
        class="border-border/60 absolute top-0 left-0 overflow-hidden rounded-[28px] border bg-white shadow-surface"
        :style="{
          width: `${width}px`,
          height: `${PREVIEW_HEIGHT}px`,
          transform: `scale(${scale})`,
          transformOrigin: 'top left'
        }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
